<template>
    <div>
        <Card>
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow" :gutter="16">
                    <Col span="24">
                        <search-card
                            :form="mainTable.searchForm"
                            :table-load-event="getSaleStatList"
                            :table-search="mainTable.tableSearch"
                        />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">客户销售统计</span>
                            <span style="margin-left: 20px">统计时间:</span>
                            <span style="margin-left: 20px">会员类别:</span>
                            <RadioGroup
                                v-model="userType"
                                style="margin-left: 4px"
                                @on-change="onUserTypeChage"
                            >
                                <Radio label="F"> <span>外部会员</span></Radio>
                                <Radio label="E"> <span>内部会员</span></Radio>
                            </RadioGroup>
                            <DatePicker
                                type="daterange"
                                v-model="selectDates"
                                size="small"
                                transfer
                                placement="bottom-end"
                                placeholder="选择期初和期末时间"
                                style="margin-left: 4px; width: 200px"
                                @on-change="onDateChange"
                            ></DatePicker>
                            <Button
                                type="warning"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                @click="showMonthlySale()"
                                >每月销售</Button
                            >
                        </div>
                        <div class="right-bar">
                            <Button
                                type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                @click="onExport()"
                                >导出</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchCardShow =
                                        !mainTable.sarchCardShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.statColumns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :extHeight="-50"
                        :table-load-event="getSaleStatList"
                        :showPage="false"
                    />
                </Col>
                <Col span="24">
                    <div class="formula-section">
                        <h3 class="formula-title">
                            <div style="margin-right: 8px">计算公式:</div>
                        </h3>
                        <div class="formula-item">
                            <strong>有效金额</strong> = 销售金额 - 优惠金额 - 代金券 -
                            退货金额
                        </div>
                        <div class="formula-item">
                            <strong>净收入</strong> = 有效金额 + 收违约金 -
                            客户经理提成 - IT/客服提成 - 种苗网基金 - 退款金额 -
                            退纸箱费 - 退违约金
                        </div>
                    </div>
                </Col>
            </Row>
        </Card>

        <Modal
            v-model="depositDetail.show"
            title="定金明细"
            :width="1200"
            :closable="false"
            footer-hide
        >
            <Row :gutter="16">
                <Col span="24">
                    <div class="right-bar onExportDetails">
                        <Button
                            type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            @click="onDetailExport()"
                            >导出</Button
                        >
                    </div>
                    <stand-pagination-table
                        :columns="depositDetail.columns"
                        :data="depositDetail.data"
                        :loading="depositDetail.loading"
                        :table-search="depositDetail.tableSearch"
                        :table-load-event="showDepositDetail"
                        summaryLabelField = "depositBillRecordCode"
                        :summaryFields="['liquidatedDamagesQuantity', 'totalOrderCost']"
                        :autoHeight="true"
                        :showPage="true"
                    />
                </Col>
            </Row>
            <div slot="header" class="div-header">
                <Button class="btn-font" type="text" @click="cancal">✕</Button>
            </div>
        </Modal>

        <Modal v-model="monthlySaleModal.show" :width="1000" footer-hide>
            <Spin v-if="monthlySaleModal.innerSpin" size="large" fix></Spin>
            <div slot="header">
                <span style="font-weight: bold; font-size: 14px"
                    >每月销售统计</span
                >
                <DatePicker
                    v-model="monthlySaleModal.year"
                    type="year"
                    size="small"
                    placeholder="选择年份"
                    style="width: 100px; margin-left: 10px"
                    @on-change="onYearChange"
                ></DatePicker>
            </div>
            <MonthlySaleBar
                ref="monthlySaleBar"
                style="height: 400px; width: 100%"
                :value="monthlySaleModal.barData"
                :text="monthlySaleModal.title"
            />
        </Modal>

        <PreSaleOrderDetail ref="preSaleOrderDetailModal" />
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from '@/components/pagination-table/pagination-table.vue';
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import {
    numberToFixed,
    number2ThousandsFormat
} from "@/components/number-input/display-format";
import { getThisMonthStart, getTodayDateString } from "@/libs/logic";
import {
    getMemberCombineSaleStat,
    getMemberCombineSaleStatDetail,
    getMonthlySaleStat,
    getMemberCombineSaleStatSql,
    getMemberCombineSaleStatSqlDetail
} from "@/api/modules/sale-management/sale-stat";
import { DOWNLOAD_SERVER } from "@/api/modules/files";
import PreSaleOrderDetail from "@/view/preSale-management/preSale-order/deposit-order-detail";
import { addSumData } from "@/libs/logic";
import MonthlySaleBar from "@/components/charts/monthly-sale-bar.vue";

export default {
    name: "sale-member-stat-list",
    components: {
        StandPaginationTable,
        SearchCard,
        PreSaleOrderDetail,
        MonthlySaleBar
    },
    data() {
        return {
            userType: "F",
            selectDates: [],
            depositDetail: {
                uuid: "",
                show: false,
                loading: false,
                columns: [
                    { title: "苗场编号", key: "seedFarmCode", align: "center" },
                    { title: "苗场名称", key: "seedFarmName", align: "center" },
                    {
                        title: "定金单号",
                        key: "depositBillRecordCode",
                        width: 180,
                        align: "center"
                        /* render: (h, params) => {
                            return h(
                                "a",
                                {
                                    on: {
                                        click: () => {
                                            this.$refs.preSaleOrderDetailModal.showModal(
                                                params.row.orderUuid
                                            );
                                        },
                                    },
                                },
                                params.row.orderCode
                            );
                        }, */
                    },
                    {
                        title: "发货单号",
                        key: "preSaleDeliveryRecordCode",
                        width: 180,
                        align: "center"
                        
                    },
                    { title: "会员编号", key: "userName", align: "center" },
                    { title: "会员名称", key: "userPersonName", align: "center" },
                    {
                        title: "转运站编号",
                        key: "distributionStationCode",
                        align: "center"
                    },
                    {
                        title: "转运站名称",
                        key: "distributionStationName",
                        align: "center"
                    },
                    {
                        title: "发货单定金",
                        key: "totalOrderCost",
                        align: "right",
                        width: 80,
                        render: (h, params) => {
                            const totalOrderCost = params.row.totalOrderCost
                                ? params.row.totalOrderCost
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        totalOrderCost,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    }
                ],
                tableSearch: search.getSearchParams(),
                data: []
            },
            mainTable: {
                statColumns: [
                    {
                        title: "苗场编号",
                        key: "seedFarmCode",
                        width: 140,
                        align: "center"
                    },
                    {
                        title: "苗场名称",
                        key: "groupName",
                        width: 140,
                        align: "center"
                    },
                    {
                        title: "本批发货量",
                        key: "saleQuantity",
                        width: 140,
                        align: "center"
                    },
                    {
                        title: "实际发货量",
                        key: "saleCount",
                        width: 140,
                        align: "center"
                    },
                    {
                        title: "销售金额",
                        key: "saleValue",
                        align: "right",
                        render: (h, params) => {
                            const saleValue = params.row.saleValue
                                ? params.row.saleValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(saleValue, 2, "￥")
                                )
                            ]);
                        }
                    },
                    {
                        title: "优惠金额",
                        key: "saleDiscountValue",
                        align: "right",
                        render: (h, params) => {
                            const saleDiscountValue = params.row
                                .saleDiscountValue
                                ? params.row.saleDiscountValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        saleDiscountValue,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "代金券",
                        key: "voucherAmount",
                        align: "right",
                        render: (h, params) => {
                            const voucherAmount = params.row.voucherAmount ? params.row.voucherAmount : 0;
                            return h("div", {}, [
                                h( "span", {},  number2ThousandsFormat( voucherAmount, 2, "￥" ) )
                            ]);
                        }
                    },
                    /*{
                        title: "退货金额",
                        key: "refundTotalVal",
                        align: "right",
                        render: (h, params) => {
                            const refundTotalVal = params.row.refundTotalVal
                                ? params.row.refundTotalVal
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        refundTotalVal,
                                        2,
                                        "￥"
                                    )
                                ),
                            ]);
                        },
                    },*/
                    {
                        title: "有效金额",
                        key: "saleRealValue",
                        align: "right",
                        render: (h, params) => {
                            const saleRealValue = params.row.saleRealValue
                                ? params.row.saleRealValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        saleRealValue,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "客户经理提成",
                        key: "managerCommission",
                        align: "right",
                        render: (h, params) => {
                            const managerCommission = params.row
                                .managerCommission
                                ? params.row.managerCommission
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        managerCommission,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "种苗网基金",
                        key: "seedStock",
                        align: "right",
                        render: (h, params) => {
                            const seedStock = params.row.seedStock
                                ? params.row.seedStock
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(seedStock, 2, "￥")
                                )
                            ]);
                        }
                    },
                    {
                        title: "IT/客服提成",
                        key: "itCommission",
                        align: "right",
                        render: (h, params) => {
                            const itCommission = params.row.itCommission
                                ? params.row.itCommission
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        itCommission,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "退款金额",
                        key: "compensationTotalValue",
                        align: "right",
                        render: (h, params) => {
                            const compensationTotalValue = params.row
                                .compensationTotalValue
                                ? params.row.compensationTotalValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        compensationTotalValue,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "退纸箱费",
                        key: "paybackPackageFeeValue",
                        align: "right",
                        render: (h, params) => {
                            const paybackPackageFeeValue = params.row
                                .paybackPackageFeeValue
                                ? params.row.paybackPackageFeeValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        paybackPackageFeeValue,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "收违约金",
                        key: "liquidatedDamageInValue",
                        align: "right",
                        render: (h, params) => {
                            const liquidatedDamageInValue = params.row
                                .liquidatedDamageInValue
                                ? params.row.liquidatedDamageInValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        liquidatedDamageInValue,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "退违约金",
                        key: "liquidatedDamageOutValue",
                        align: "right",
                        render: (h, params) => {
                            const liquidatedDamageOutValue = params.row
                                .liquidatedDamageOutValue
                                ? params.row.liquidatedDamageOutValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        liquidatedDamageOutValue,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    /* {
                        title: '转运站包装费',
                        key: 'sPackageFee',
                        align: 'right',
                        render: (h, params) => {
                            const sPackageFee = params.row.sPackageFee ? params.row.sPackageFee : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(sPackageFee, 2, '￥'))
                            ]);
                        }
                    },
                    {
                        title: '转运站配送费',
                        key: 'sDeliveryFee',
                        align: 'right',
                        render: (h, params) => {
                            const sDeliveryFee = params.row.sDeliveryFee ? params.row.sDeliveryFee : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(sDeliveryFee, 2, '￥'))
                            ]);
                        }
                    }, */
                    {
                        title: "净收入",
                        key: "netIncomde",
                        align: "right",
                        render: (h, params) => {
                            const netIncomde = params.row.netIncomde
                                ? params.row.netIncomde
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(netIncomde, 2, "￥")
                                )
                            ]);
                        }
                    },
                    {
                        title: "苗场包装费",
                        key: "sfPackageFee",
                        align: "right",
                        render: (h, params) => {
                            const sfPackageFee = params.row.sfPackageFee
                                ? params.row.sfPackageFee
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        sfPackageFee,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "苗场配送费",
                        key: "sfDeliveryFee",
                        align: "right",
                        render: (h, params) => {
                            const sfDeliveryFee = params.row.sfDeliveryFee
                                ? params.row.sfDeliveryFee
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        sfDeliveryFee,
                                        2,
                                        "￥"
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            if (params.row.action != -1) {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small",
                                                shape: "circle"
                                            },
                                            on: {
                                                click: () => {
                                                    this.showSeedFarmDepositDetail(
                                                        params.row.seedFarmUuid
                                                    );
                                                }
                                            }
                                        },
                                        "定金明细"
                                    )
                                ]);
                            }
                            else {
                                return "";
                            }
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    {
                        label: "会员",
                        type: "Input",
                        value: "",
                        name: "searchUserName",
                        sql: "like"
                    },
                    {
                        label: "苗场",
                        type: "Input",
                        value: "",
                        name: "searchSeedFarmName",
                        sql: "like"
                    },
                    {
                        label: "用友",
                        type: "Input",
                        value: "",
                        name: "searchYS",
                        sql: "like"
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            monthlySaleModal: {
                show: false,
                innerSpin: false,
                year: new Date(),
                barData: {},
                title: ""
            },
            seedFarmUuid: ""
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        number2ThousandsFormat,
        cancal() {
            this.depositDetail.tableSearch.limit.conditions.pageStart = 1;
            this.depositDetail.tableSearch.limit.conditions.pageLength = 10;
            this.depositDetail.show = false;
        },
        showMonthlySale() {
            this.monthlySaleModal.show = true;
            this.getMonthlySaleData();
        },
        onYearChange() {
            this.getMonthlySaleData();
        },
        getMonthlySaleData() {
            this.monthlySaleModal.innerSpin = true;
            getMonthlySaleStat({
                year: this.monthlySaleModal.year,
                userType: this.userType
            }).then((res) => {
                this.monthlySaleModal.innerSpin = false;
                if (res.code === 0) {
                    this.monthlySaleModal.barData = res.data.monthSaleDict;
                    this.monthlySaleModal.title = `全年销售总额:${number2ThousandsFormat(
                        res.data.totalSale,
                        2,
                        "￥"
                    )}`;
                    this.$refs.monthlySaleBar.init();
                }
            });
        },
        init() {
            this.getSaleStatList();
        },
        onExport() {
            this.mainTable.loading = true;
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 1;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getMemberCombineSaleStatSql(this.mainTable.tableSearch).then((res) => {
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                        // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                    }
                }
                this.mainTable.loading = false;
            });
        },
        onDetailExport() {
            this.depositDetail.tableSearch.filters.conditions = [];
            //将主列表的搜索条件遍历赋值给明细列表，成为明细列表的搜索条件
            this.mainTable.tableSearch.filters.conditions.forEach((item) => {
                search.globalRemoveFilterConditionKey(
                    this.depositDetail.tableSearch,
                    item.name
                );
                this.depositDetail.tableSearch.filters.enable = true;
                this.depositDetail.tableSearch.filters.conditions.push({
                    name: item.name,
                    type: "eq",
                    value: item.value
                });
            });
            this.depositDetail.tableSearch.filters.conditions.push({
                name: "date",
                type: "eq",
                value: JSON.stringify(
                    this.selectDates.map(d => d.toISOString())
                )
            });
            this.depositDetail.tableSearch.filters.conditions.push({
                name: "seedFarmUuid",
                type: "eq",
                value: this.seedFarmUuid
            });
            
            this.depositDetail.tableSearch.excelExport.enable = true;
            this.depositDetail.loading = true;
            getMemberCombineSaleStatSqlDetail(this.depositDetail.tableSearch).then(
                (res) => {
                    this.depositDetail.loading = false;
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                    this.mainTable.tableSearch.limit.enable = false;
                }
            );
        },
        onDateChange() {
            this.getSaleStatList();
        },
        showDepositDetail() {
            this.depositDetail.tableSearch.filters.conditions = [];
            //将主列表的搜索条件遍历赋值给明细列表，成为明细列表的搜索条件
            this.mainTable.tableSearch.filters.conditions.forEach((item) => {
                search.globalRemoveFilterConditionKey(
                    this.depositDetail.tableSearch,
                    item.name
                );
                this.depositDetail.tableSearch.filters.enable = true;
                this.depositDetail.tableSearch.filters.conditions.push({
                    name: item.name,
                    type: "eq",
                    value: item.value
                });
            });
            this.depositDetail.tableSearch.filters.conditions.push({
                name: "date",
                type: "eq",
                value: JSON.stringify(
                    this.selectDates.map(d => d.toISOString())
                )
            });
            this.depositDetail.tableSearch.filters.conditions.push({
                name: "seedFarmUuid",
                type: "eq",
                value: this.seedFarmUuid
            });
            this.depositDetail.tableSearch.excelExport.enable = false;
            this.depositDetail.show = true;
            this.depositDetail.loading = true;
            getMemberCombineSaleStatSqlDetail(this.depositDetail.tableSearch).then(
                (res) => {
                    this.depositDetail.loading = false;
                    if (res.code === 0) {
                        this.depositDetail.data
                            = res.data.listDepositDetailInfo;

                        search.globalSetFilterRecordCount(
                            this.depositDetail.tableSearch,
                            res.data.filterRecordCount
                        );
                    }
                }
            );
        },
        onUserTypeChage() {
            this.getSaleStatList();
        },
        getSaleStatList(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(
                    this.mainTable.tableSearch,
                    "memberType"
                );
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: "memberType",
                    type: "eq",
                    value: this.userType
                });
            }
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getMemberCombineSaleStatSql(this.mainTable.tableSearch)
                .then((res) => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        this.mainTable.data = res.data.listCombine;

                        let sumFileds = [
                            "saleQuantity",
                            "saleCount",
                            "saleValue",
                            "saleDiscountValue",
                            "refundTotalVal",
                            "saleRealValue",
                            "managerCommission",
                            "itCommission",
                            "seedStock",
                            "compensationTotalValue",
                            "paybackPackageFeeValue",
                            "liquidatedDamageInValue",
                            "liquidatedDamageOutValue",
                            "sfDeliveryFee",
                            "sfPackageFee",
                            "netIncomde",
                            "voucherAmount"
                        ];
                        let sumData = addSumData(
                            this.mainTable.data,
                            "groupName",
                            sumFileds
                        );
                        this.mainTable.data.push(sumData);

                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        showSeedFarmDepositDetail(uuid) {
            this.seedFarmUuid = uuid;
            
            
            this.showDepositDetail();
        }
    }
};
</script>

<style scoped>
.div-header {
    display: flex;
    justify-content: flex-end;
}
.div-header .btn-font {
    font-size: 18px;
    line-height: 0 !important;
}
.onExportDetails {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
}
.formula-section {
    background-color: #f0f8ff;
    border: 1px solid #cce5ff;
    border-left: 5px solid #007bff;
    padding: 20px;
    margin-top: 5px;
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.formula-title {
    font-size: 1.3em;
    font-weight: bold;
    color: #004085;
    margin-top: 0;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.formula-item {
    font-size: 1.1em;
    color: red;
    line-height: 1.8;
    margin-bottom: 10px;
}

.formula-item:last-child {
    margin-bottom: 0;
}

.formula-item strong {
    color: red;
    margin-right: 5px;
}
</style>
